import { Icon } from './icon';

export const IconMinus = () => (
  <Icon>
    <path d="M3 12L21 12" />
  </Icon>
);
